define("shared/components/shared/wizard/slide/header", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <@modal.card-header>
    {{yield}}
  </@modal.card-header>
  
  */
  {
    "id": "vl7RXLPT",
    "block": "[[[8,[30,1,[\"card-header\"]],null,null,[[\"default\"],[[[[1,\"\\n  \"],[18,2,null],[1,\"\\n\"]],[]]]]],[1,\"\\n\"]],[\"@modal\",\"&default\"],false,[\"yield\"]]",
    "moduleName": "shared/components/shared/wizard/slide/header.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});